import React, {
  useState,
  useEffect,
} from 'react';

import {
  TextInput,
  Textarea,
} from 'web-components';

type Props = {
  isTextarea: boolean,
  defaultValue: any,
  onSave?: { (): void },
  onSaveEnter?: { (): void },
};

const InlineInput = ({
  isTextarea,
  defaultValue,
  onSave,
  onSaveEnter,
  ...restProps
}: Props) => {
  const [value, setValue] = useState('');

  useEffect(() => {
    setValue(defaultValue || '');
  }, [defaultValue]);

  const Input = isTextarea ? Textarea : TextInput;

  return (
    <Input
      {...restProps}
      value={value}
      onChange={e => setValue(e.target.value)}
      onKeyPress={(e) => {
        if (
          e.key === 'Enter'
          && value !== defaultValue
          && onSaveEnter
        ) {
          onSaveEnter(value);
        }
      }}
      onBlur={() => {
        if (value !== defaultValue) {
          if (onSave) {
            onSave(value);
          } else {
            setValue(defaultValue);
          }
        }
      }}
    />
  );
};

InlineInput.defaultProps = {
  onSave: null,
  onSaveEnter: null,
};

export default InlineInput;
